import { DisclosureSize } from "@gravity-ui/uikit";

import { IKBSection } from "../../types";
import { SectionItem } from "./components";

interface KnowledgeSidebarProps {
  tree: IKBSection[];
  basePath: string;
  activeSection: string;
  currentSlugPath: string;
  isMobileDialogOpen?: boolean;
  onClick?: (open: boolean) => void;
  size: DisclosureSize;
}

export const KnowledgeSidebar = ({
  basePath,
  tree,
  activeSection,
  currentSlugPath,
  isMobileDialogOpen,
  size,
  onClick,
}: KnowledgeSidebarProps) => {
  return (
    <>
      {tree.map((section) => {
        return (
          <SectionItem
            key={section.slug}
            section={section}
            basePath={basePath}
            size={size}
            activeSectionSlug={activeSection}
            currentSlugPath={currentSlugPath}
            onClick={() =>
              onClick && isMobileDialogOpen
                ? onClick(!isMobileDialogOpen)
                : undefined
            }
          />
        );
      })}
    </>
  );
};
